import { gql } from '@apollo/client';

export const START_HOME_SESSION = gql`
  mutation START_HOME_SESSION($id: ID!, $candidateBirthDate: String, $candidateBirthPostCode: String) {
    startHomeSessionResult: startHomeSession(
      id: $id
      candidateBirthDate: $candidateBirthDate
      candidateBirthPostCode: $candidateBirthPostCode
    ) {
      ... on StartHomeSessionSuccess {
        hasSucceeded
      }
      ... on StartHomeSessionError {
        reason
        hasSucceeded
      }
    }
  }
`;
